
      import {
        SAO_ORIENTATION_STORAGE_KEY,
        SAO_ORIENTATIONS,
        SAO_PIN_MAP,
        SAO_SLOT_ORIENTATION_MAP,
        normalizeSaoOrientation,
      } from "./src/lib/protocol.js";

      const toggle = document.querySelector("#sao-orientation");
      const state = document.querySelector("#sao-orientation-state");
      const labels = [...document.querySelectorAll("[data-sao-slot]")];

      function describeSlot(slot, orientation) {
        const physicalSlot = SAO_SLOT_ORIENTATION_MAP[orientation][slot];
        const pin = SAO_PIN_MAP[physicalSlot];
        if (orientation === SAO_ORIENTATIONS.FLIPPED) return `maps to SAO ${physicalSlot} · pin ${pin}`;
        return `PC${pin === 21 ? 5 : pin === 22 ? 6 : pin - 16} · pin ${pin}`;
      }

      function setOrientation(orientation) {
        const normalized = normalizeSaoOrientation(orientation);
        toggle.checked = normalized === SAO_ORIENTATIONS.FLIPPED;
        state.textContent = toggle.checked ? "Flipped mapping: 1↔4, 2↔3" : "Standard mapping";
        for (const label of labels) {
          label.textContent = describeSlot(Number(label.dataset.saoSlot), normalized);
        }
        try {
          localStorage.setItem(SAO_ORIENTATION_STORAGE_KEY, normalized);
        } catch {}
      }

      try {
        setOrientation(localStorage.getItem(SAO_ORIENTATION_STORAGE_KEY));
      } catch {
        setOrientation(SAO_ORIENTATIONS.STANDARD);
      }
      toggle.addEventListener("change", () => {
        setOrientation(toggle.checked ? SAO_ORIENTATIONS.FLIPPED : SAO_ORIENTATIONS.STANDARD);
      });
    